import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import useService from "../../Hooks/useService";
import AttendanceService from "../../../Services/Attendance.service";
import CourseSectionMeetingService from "../../../Domain/CourseSectionMeeting/CourseSectionMeeting.service";
const MissingAttendance = (props) => {
    const [missingAttendance, loadMissingAttendance] = useService(AttendanceService.getMissingAttendance);
    // Load missing attendance
    React.useEffect(() => {
        if (props.courseSectionId) {
            loadMissingAttendance(props.courseSectionId);
        }
    }, [loadMissingAttendance, props.courseSectionId]);
    const isSelected = React.useCallback((meeting) => meeting.sourceScheduleElement.id ===
        (props.selectedMeeting &&
            props.selectedMeeting.sourceScheduleElementId) &&
        meeting.meetingStartDate.toDateString() ===
            (props.selectedMeeting &&
                props.selectedMeeting.meetingStartDate.toDateString()), [props.selectedMeeting]);
    if (missingAttendance.isLoading) {
        // Just don't show anything if we're loading missing attendance
        return null;
    }
    if (missingAttendance.wasSuccessful &&
        missingAttendance.data &&
        (!missingAttendance.data.meetingsMissingAttendance ||
            missingAttendance.data.meetingsMissingAttendance.length === 0)) {
        return null;
    }
    return (_jsxs("div", { className: "card", children: [_jsxs("div", { className: "card-header bg-white", children: ["Missing Attendance", " ", missingAttendance.data &&
                        missingAttendance.data.meetingsMissingAttendance && (_jsxs("span", { children: ["(", missingAttendance.data.meetingsMissingAttendance.length, ")"] }))] }), missingAttendance.data && (_jsx("div", { className: "list-group list-group-flush", children: missingAttendance.data.meetingsMissingAttendance.map((item, index) => (_jsx("div", { className: `list-group-item list-group-item-action border-bottom-0 border-top-0 clickable ${isSelected(item) ? "active" : ""}`, onClick: () => props.setSelectedMeetingId({
                        sourceScheduleElementId: item.sourceScheduleElement.id,
                        meetingStartDate: item.meetingStartDate,
                    }), children: isSelected(item) ? (CourseSectionMeetingService.display(item)) : (_jsx("a", { href: "#", children: CourseSectionMeetingService.display(item) })) }, index))) }))] }));
};
export default MissingAttendance;
